import { types, getParent, type Instance } from 'mobx-state-tree';

/** The FSM tools (the `activeTool` enumeration). */
type FSMTool = 'add_initial_state' | 'add_state' | 'add_final_state' | 'add_transition';

// The FSM store's parent is the UI store; the FSM view only reads `selected`
// from it. Narrow structural interface to avoid an import cycle with the UI
// store (which embeds FSM).
interface IFSMUIParent {
  readonly selected: string | null;
}

/**
 * UI state for the EDG view.
 */
const FSM = types
  .model('UIFSM', {
    // which tool is active
    activeTool: types.maybe(
      types.enumeration(['add_initial_state', 'add_state', 'add_final_state', 'add_transition'])
    ),
  })
  .views(self => ({
    /**
     * Return an array of elements that should be highlighted.
     *
     * Returns an array with the 'selected' property of the parent store or an
     * empty array if that one is falsy.
     */
    get highlighted() {
      const selected = getParent<IFSMUIParent>(self).selected;
      if (selected) {
        return [selected];
      } else {
        return [];
      }
    },
  }))
  .actions(self => ({
    toggleTool(tool: FSMTool) {
      if (self.activeTool === tool) {
        self.activeTool = undefined;
      } else {
        self.activeTool = tool;
      }
    },
    deactivateTool() {
      self.activeTool = undefined;
    },
  }));

export type IUIFSM = Instance<typeof FSM>;

export default FSM;
